/* istanbul ignore file */

import Homepage from '../pages/Homepage';

const base = '/bukaemas';

const routes = [
  {
    path: `${base}/`,
    name: 'Homepage',
    component: Homepage,
  },
];

export default routes;
